import { useState } from "react";
import uniqueId from "lodash.uniqueid";

export const setId = (...args: (string | undefined)[]): string | undefined =>
  args.some((v) => v == null) ? undefined : args.join("-");

export const useUniqueId = (id?: string, idPrefix?: string): string =>
  useState(id || uniqueId(idPrefix))[0];
